import React from 'react';
import { companyInfo } from '../../data/mockData';

export const FounderProfile = () => (
  <div className="about-image">
    <img
      src="https://customer-assets.emergentagent.com/job_dba9b77f-2bec-4d59-9c0d-9f2fc088db35/artifacts/qmnmr0x0_Photo.jpeg"
      alt={`${companyInfo.founder} — Founder, SS Consultancy`}
      className="founder-photo"
    />
    <div style={{ marginTop: '1.5rem' }}>
      <h3 style={{ fontSize: '1.35rem', fontWeight: 700, color: 'var(--primary-navy)', marginBottom: '0.4rem' }}>
        {companyInfo.founder}
      </h3>
      <p style={{ color: 'var(--accent-gold-dark)', fontWeight: 600, marginBottom: '1rem' }}>
        Founder · Wealth Advisor
      </p>
      <div className="credentials">
        <span className="credential-badge">MBA Finance</span>
        <span className="credential-badge">AMFI Registered</span>
        <span className="credential-badge">{companyInfo.arn}</span>
      </div>
    </div>
  </div>
);
